/* eslint-disable no-useless-escape */
import moment from 'moment-timezone'
import { findIana } from 'windows-iana'
import { isEqual } from 'lodash'
import { errorCodes, getUserFriendlyErrorMessage } from './errormessages'
import { ABBREVIATION_TO_DAY_OF_WEEK, DRUG_SCREEN_STATUS, ID_VERIFICATION_STATUSES } from './constants'
import { safeLocalStorage } from '@quickmd-llc/frontend-utils'
import { addSentryBreadcrumb } from './sentryUtility'

export const emojiRegex =
  /\uD83C\uDFF4(?:\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\u200D\u2620\uFE0F)|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])|(?:[#*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDD1-\uDDDD])/g

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitStatus = (status) => {
  switch (status) {
    case 'inwaitingroom':
      return 'In waiting room'
    case 'inprogress':
      return 'In progress'
    case 'unresolved':
      return 'Unresolved'
    case 'resolved':
      return 'Resolved'
    case 'cancelledbypatient':
      return 'Canceled by patient'
    case 'scheduledbypatient':
      return 'Patient scheduled'
    case 'rescheduledbypatient':
      return 'Patient rescheduled'
    case 'scheduledbyadmin':
      return 'Staff scheduled'
    case 'ended':
      return 'Ended'
    case 'completed':
      return 'Complete'
    case 'cancelledbyadmin':
      return 'Canceled by staff'
    case 'rescheduledbyadmin':
      return 'Staff rescheduled'
    default:
      break
  }
}

const statesOptions = [
  'Alabama AL',
  'Alaska AK',
  'Arizona AZ',
  'Arkansas AR',
  'California CA',
  'Colorado CO',
  'Connecticut CT',
  'Delaware DE',
  'District of Columbia DC',
  'Florida FL',
  'Georgia GA',
  'Hawaii HI',
  'Idaho ID',
  'Illinois IL',
  'Indiana IN',
  'Iowa IA',
  'Kansas KS',
  'Kentucky KY',
  'Louisiana LA',
  'Maine ME',
  'Maryland MD',
  'Massachusetts MA',
  'Michigan MI',
  'Minnesota MN',
  'Mississippi MS',
  'Missouri MO',
  'Montana MT',
  'Nebraska NE',
  'Nevada NV',
  'New Hampshire NH',
  'New Jersey NJ',
  'New Mexico NM',
  'New York NY',
  'North Carolina NC',
  'North Dakota ND',
  'Ohio OH',
  'Oklahoma OK',
  'Oregon OR',
  'Pennsylvania PA',
  'Rhode Island RI',
  'South Carolina SC',
  'South Dakota SD',
  'Tennessee TN',
  'Texas TX',
  'Utah UT',
  'Vermont VT',
  'Virginia VA',
  'Washington WA',
  'West Virginia WV',
  'Wisconsin WI',
  'Wyoming WY',
]

export const states = [
  { state: 'Alabama', code: 'AL' },
  { state: 'Alaska', code: 'AK' },
  { state: 'Arizona', code: 'AZ' },
  { state: 'Arkansas', code: 'AR' },
  { state: 'California', code: 'CA' },
  { state: 'Colorado', code: 'CO' },
  { state: 'Connecticut', code: 'CT' },
  { state: 'Delaware', code: 'DE' },
  { state: 'District of Columbia', code: 'DC' },
  { state: 'Florida', code: 'FL' },
  { state: 'Georgia', code: 'GA' },
  { state: 'Hawaii', code: 'HI' },
  { state: 'Idaho', code: 'ID' },
  { state: 'Illinois', code: 'IL' },
  { state: 'Indiana', code: 'IN' },
  { state: 'Iowa', code: 'IA' },
  { state: 'Kansas', code: 'KS' },
  { state: 'Kentucky', code: 'KY' },
  { state: 'Louisiana', code: 'LA' },
  { state: 'Maine', code: 'ME' },
  { state: 'Maryland', code: 'MD' },
  { state: 'Massachusetts', code: 'MA' },
  { state: 'Michigan', code: 'MI' },
  { state: 'Minnesota', code: 'MN' },
  { state: 'Mississippi', code: 'MS' },
  { state: 'Missouri', code: 'MO' },
  { state: 'Montana', code: 'MT' },
  { state: 'Nebraska', code: 'NE' },
  { state: 'Nevada', code: 'NV' },
  { state: 'New Hampshire', code: 'NH' },
  { state: 'New Jersey', code: 'NJ' },
  { state: 'New Mexico', code: 'NM' },
  { state: 'New York', code: 'NY' },
  { state: 'North Carolina', code: 'NC' },
  { state: 'North Dakota', code: 'ND' },
  { state: 'Ohio', code: 'OH' },
  { state: 'Oklahoma', code: 'OK' },
  { state: 'Oregon', code: 'OR' },
  { state: 'Pennsylvania', code: 'PA' },
  { state: 'Rhode Island', code: 'RI' },
  { state: 'South Carolina', code: 'SC' },
  { state: 'South Dakota', code: 'SD' },
  { state: 'Tennessee', code: 'TN' },
  { state: 'Texas', code: 'TX' },
  { state: 'Utah', code: 'UT' },
  { state: 'Vermont', code: 'VT' },
  { state: 'Virginia', code: 'VA' },
  { state: 'Washington', code: 'WA' },
  { state: 'West Virginia', code: 'WV' },
  { state: 'Wisconsin', code: 'WI' },
  { state: 'Wyoming', code: 'WY' },
]

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const isValidStateCode = (code) => code?.length === 2

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getState = (value) => {
  if (!value) return ''
  if (isValidStateCode(value)) {
    return states.find((item) => item.code === value.toUpperCase()) || ''
  }
  return states.find((item) => item.state.toLowerCase().trim() === value.toLowerCase().trim()) || ''
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getStateCodeFromValue = (value) => {
  let stateCode = value
  if (isValidStateCode(stateCode)) {
    return stateCode
  }
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  stateCode = getState(stateCode)?.code
  if (stateCode) {
    return stateCode
  }

  return ''
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const checkIsNeedUpdatePatientChartSection = (tabId) => {
  const reloadedTabId = safeLocalStorage.get('reloadedPatientChartPageTabId')
  return reloadedTabId === tabId || reloadedTabId === null
}

export const setTabId = () => {
  const newTabId = Date.now().toString()
  try {
    sessionStorage.setItem('tabId', newTabId)
  } catch {
    // sessionStorage unavailable (e.g. restricted WebView environment)
  }
}

export const getTabId = () => {
  try {
    return sessionStorage.getItem('tabId')
  } catch {
    return null
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const removeEmojis = (string) => string.replace(emojiRegex, '')
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getStateByAbbreviation = (abbr) => {
  if (abbr) {
    if (abbr === 'VI') {
      return 'Virgins Island'
    }
    if (abbr === 'PR') {
      return 'Puerto Rico'
    }
    const state = statesOptions.find((t) => t.includes(abbr))
    // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
    return state.slice(0, -2)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const isObjectEmpty = (obj) => Object.keys(obj).length === 0
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function isEllipsisActive(e, isMultipleLine = false) {
  if (e) {
    if (isMultipleLine) {
      return e.offsetHeight <= e.scrollHeight
    }

    return e.offsetWidth < e.scrollWidth
  }
  return false
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const isActiveEllipsisCheck = (id, stateChangeCallBack, type) => {
  if (isEllipsisActive(document.getElementById(id), type)) {
    stateChangeCallBack(true)
  } else {
    stateChangeCallBack(false)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const validateEmail = (email) =>
  String(email)
    .toLowerCase()
    .match(/^(?!\.)(?!.*\.$)(?!.*\.\.)(?!.*\.@)[a-zA-Z0-9_.+-]+@(?!\.)[a-zA-Z0-9_.+-]+\.[a-zA-Z0-9_.+-]+$/)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAge = (dateString) => moment().diff(dateString, 'years')

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const VisitTimeCreator = (dateString) => {
  const iscurrentdate = moment(dateString).isSame(new Date(), 'day')
  const isYesterdayDate = moment(dateString).isSame(moment().subtract(1, 'day'), 'day')
  const onlyHoursAndMinutes = moment(dateString).format('hh:mma')

  return (
    iscurrentdate ? `Today, ${onlyHoursAndMinutes}`
    : isYesterdayDate ? `Yesterday, ${onlyHoursAndMinutes}`
    : moment(dateString).format('MM/DD/YYYY hh:mma')
  )
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const checkInTimerRowCreator = (dateString, afterTimeOnly = false) => {
  const onlyHoursAndMinutes = moment(dateString).format('hh:mma')
  const ms = moment(dateString).diff(moment())
  const d = moment.duration(ms)

  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  let { hours, minutes, seconds, days } = d._data
  hours =
    days !== 0 ? days * -24 + hours * -1
    : hours < 0 ? hours * -1
    : hours
  minutes = minutes < 0 ? minutes * -1 : minutes
  seconds = seconds < 0 ? seconds * -1 : seconds
  const afterTime = `${
    hours > 0 ?
      hours < 10 ?
        `0${hours}:`
      : `${hours}:`
    : ''
  }${
    minutes > 0 ?
      minutes < 10 ?
        `0${minutes}`
      : minutes
    : '00'
  }:${
    seconds > 0 ?
      seconds < 10 ?
        `0${seconds}`
      : seconds
    : '00'
  }`
  if (afterTimeOnly) return afterTime
  return `${onlyHoursAndMinutes} (${afterTime})`
}

export const getTimeOptionsList = () => {
  const times = [] // time array
  let tt = 0 // start time
  const ap = ['am', 'pm']
  for (let i = 0; tt < 24 * 60; i += 1) {
    const hh = Math.floor(tt / 60)
    const mm = tt % 60
    const hoursView = `0${hh % 12}`.endsWith('00') ? '12' : `0${hh % 12}`.slice(-2)
    times[i] = `${hoursView}:${`0${mm}`.slice(-2)}${ap[Math.floor(hh / 12)]}`
    tt += 15
  }
  return times
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
function timeToMinutesAfterMidnight(time) {
  const [hours, minutes] = time.match(/\d+/g).map(Number)
  const isPM = /pm/i.test(time)
  if (isPM && hours === 12) {
    return ((hours % 12) + (isPM && hours !== 12 ? 12 : 0)) * 60 + minutes + 720
  }
  return ((hours % 12) + (isPM && hours !== 12 ? 12 : 0)) * 60 + minutes
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
function minutesAfterMidnightToTime(minutesAfterMidnight) {
  const hours = Math.floor(minutesAfterMidnight / 60) % 12 || 12 // 12-hour clock
  const minutes = minutesAfterMidnight % 60
  const period = minutesAfterMidnight < 720 ? 'am' : 'pm' // determine AM or PM
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}${period}`
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getOnlyFutureAvailableTimes = (arr, date) => {
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const minutesAfterMidnightArray = arr.map((time) => timeToMinutesAfterMidnight(time))
  const nowDateInMinutes = timeToMinutesAfterMidnight(moment(date).format('hh:mma'))
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const filteredByNowDate = minutesAfterMidnightArray.filter((t) => t > nowDateInMinutes)
  const availableTimes = filteredByNowDate.length < 6 ? minutesAfterMidnightArray.slice(-6) : filteredByNowDate

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return availableTimes.map((minutes) => minutesAfterMidnightToTime(minutes))
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAgeByDate = (dateString) => moment().diff(dateString, 'years')
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAddressStringFromAddressObject = (addressObject) => {
  const { City, CountryCode, StateCode, StreetAddress1, StreetAddress2, Zip } = addressObject
  return `${StreetAddress1}, ${
    StreetAddress2 ? `${StreetAddress2}, ` : ' '
  }${City}, ${StateCode} ${Zip}, ${CountryCode}`
}

export const severitiesData = {
  severe: {
    priority: 1,
    key: 'severe',
    value: 'Severe: Anaphylaxis, chest tightness, etc',
  },
  moderate: {
    priority: 2,
    key: 'moderate',
    value: 'Moderate: tingling, swelling, rash, etc',
  },
  mild: {
    priority: 3,
    key: 'mild',
    value: 'Mild: sneezing, itching, redness',
  },
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getDays = (days, showAll = false) => {
  if (days.length === 7 && !showAll) return 'all days'
  if (!showAll && days.length === 5 && days[0] === 'monday' && days[4] === 'friday') return 'weekdays'

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  days = days.map((day) => day[0].toUpperCase() + day.slice(1))
  return days.join('; ')
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function imageSize(url) {
  const img = document.createElement('img')

  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const promise = new Promise((resolve, reject) => {
    img.onload = () => {
      const width = img.naturalWidth
      const height = img.naturalHeight
      // Resolve promise with the width and height
      resolve({ width, height })
    }
  })

  // Setting the source makes it start downloading and eventually call `onload`
  img.src = url

  return promise
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const validateLicenses = (licenseArray, setLicenseArray) => {
  // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
  let dublicatedIds = []
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const checkArray = licenseArray.map((t) => ({
    id: t.licenseBlockId,
    Number: t.licenseNumberValue,
    StateValue: t.stateLicenseValue,
    licensedByValue: t.licensedByValue,
  }))

  for (let i = 0; i < checkArray.length; i += 1) {
    const tempCheck = [...checkArray]
    const temp = { ...tempCheck[i] }
    let isDublicatedTemp = false
    for (let j = 0; j < tempCheck.length; j += 1) {
      if (temp.id === tempCheck[j].id) {
        delete tempCheck[j]
      } else if (
        temp.Number === tempCheck[j].Number &&
        temp.Number?.length > 0 &&
        tempCheck[j].Number?.length > 0 &&
        temp.StateValue === tempCheck[j].StateValue &&
        temp.StateValue?.length > 0 &&
        tempCheck[j].StateValue?.length > 0 &&
        temp?.licensedByValue?.trim() === tempCheck[j]?.licensedByValue?.trim() &&
        temp.licensedByValue?.length > 0 &&
        tempCheck[j].licensedByValue?.length > 0
      ) {
        isDublicatedTemp = true
        // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
        dublicatedIds = [...dublicatedIds, tempCheck[j].id]
        delete tempCheck[j]
      }
    }
    if (isDublicatedTemp) {
      // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
      dublicatedIds = [...dublicatedIds, temp.id]
    }
  }
  // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
  const correctDublicatesIdsList = [...new Set(dublicatedIds)]
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const correctLicenseArray = licenseArray.map((t) =>
    correctDublicatesIdsList.some((j) => j === t.licenseBlockId) ?
      {
        ...t,
        licenseNumberError: t.licensedByValue.length,
        licenseNumberLocalError:
          t.licensedByValue.length ? getUserFriendlyErrorMessage(errorCodes.DUPLICATE_LICENSES) : '',
      }
    : t,
  )
  setLicenseArray(correctLicenseArray)
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const isDuplicatedLicenses = (licenseArray) => {
  // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
  let dublicatedIds = []
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const checkArray = licenseArray.map((t) => ({
    id: t.licenseBlockId,
    Number: t.licenseNumberValue,
    StateValue: t.stateLicenseValue,
    licensedByValue: t.licensedByValue,
  }))

  for (let i = 0; i < checkArray.length; i += 1) {
    const tempCheck = [...checkArray]
    const temp = { ...tempCheck[i] }
    let isDublicatedTemp = false
    for (let j = 0; j < tempCheck.length; j += 1) {
      if (temp.id === tempCheck[j].id) {
        delete tempCheck[j]
      } else if (
        temp?.Number === tempCheck[j]?.Number &&
        temp.Number?.length > 0 &&
        tempCheck[j].Number?.length > 0 &&
        temp?.StateValue === tempCheck[j]?.StateValue &&
        temp.StateValue?.length > 0 &&
        tempCheck[j].StateValue?.length > 0 &&
        temp?.licensedByValue?.trim() === tempCheck[j]?.licensedByValue?.trim() &&
        temp.licensedByValue?.length > 0 &&
        tempCheck[j].licensedByValue?.length > 0
      ) {
        isDublicatedTemp = true
        // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
        dublicatedIds = [...dublicatedIds, tempCheck[j].id]
        delete tempCheck[j]
      }
    }
    if (isDublicatedTemp) {
      // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
      dublicatedIds = [...dublicatedIds, temp.id]
    }
  }

  return !!dublicatedIds.length
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function insert(arr, val, index) {
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return index >= arr.length ? arr.concat(val) : arr.reduce((prev, x, i) => prev.concat(i === index ? [val, x] : x), [])
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAddressValue = (address) => {
  if (address) {
    return `${address.StreetAddress1 ? `${address.StreetAddress1}, ` : ''}${
      address.StreetAddress2 ? `${address.StreetAddress2}, ` : ''
    }${address.City ? `${address.City}, ` : ''}${address.StateCode ? address.StateCode : ''}${
      address.Zip ? ` ${address.Zip}` : ''
    },${address.CountryCode ? ` ${address.CountryCode}` : ''}`
  }

  return null
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPharmacyAddressValue = (pharmacy) => {
  if (pharmacy) {
    return `${pharmacy.Name} - ${pharmacy?.Address?.StreetAddress1}, ${
      pharmacy?.Address?.StreetAddress2 ? `${pharmacy.Address?.StreetAddress2}, ` : ''
    }${pharmacy?.Address?.City}, ${pharmacy.Address?.StateCode} ${pharmacy.Address?.Zip}, ${
      pharmacy.Address?.CountryCode
    }`
  }

  return null
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPhoneNumberValue = (prefix, number) => {
  if (prefix && number) {
    return `${prefix} ${number.replace(prefix, '')}`
  }

  return null
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getBodyHeightValue = (heighInchesFromAPI) => {
  if (heighInchesFromAPI) {
    const inchesInOneFeet = 12
    const heightFeetValue = Math.floor(heighInchesFromAPI / inchesInOneFeet)
    const heightInches = heighInchesFromAPI % inchesInOneFeet
    return `${heightFeetValue} ft ${heightInches ? `${heightInches} in` : ''}`
  }

  return null
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getTimeZones = (allTimezones) => ({
  IDLW: 'International Date Line West',
  'America/Adak': 'Hawaii',
  'Pacific/Marquesas': 'Hawaii',
  'America/Guatemala': 'Central America',
  'Pacific/Kiritimati': "Nuku'alofa",
  ...allTimezones,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const capitalize = (word) => {
  if (!word) return ''

  return word.charAt(0).toUpperCase() + word.slice(1)
}

/**
 * Builds a patient's display name, optionally inserting the preferred name in quotes
 * between the first and last name, e.g. `John "Johnny" Doe`. QMD-3814.
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const formatPatientName = (patient, { includePreferred = false } = {}) => {
  if (!patient) return ''
  const firstName = patient.FirstName ?? ''
  const lastName = patient.LastName ?? ''
  const preferredName = patient.PreferredName?.trim()
  const preferred = includePreferred && preferredName ? `"${preferredName}" ` : ''
  return `${firstName} ${preferred}${lastName}`.trim()
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAuthorName = (authorData, hasUserType = true) => {
  let author

  if (authorData) {
    const { Prefix, FirstName, LastName, Suffix, UserType } = authorData

    author = Prefix ? `${Prefix} ` : ''
    author += FirstName ? `${FirstName} ` : ''
    author += LastName ? `${LastName} ` : ''
    author += Suffix ? `${Suffix} ` : ''
    if (hasUserType) {
      author += UserType ? `(${capitalize(UserType)})` : ''
    }
  } else {
    author = 'System generated'
  }

  return author
}

/**
 * Returns an array of days of the week based on the given array of day abbreviations.
 * @param {string[]} abbrArray - An array of day abbreviations.
 * @returns {string[]} An array of days of the week.
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getDaysOfWeekFromAbbreviationArr = (abbrArray) =>
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  abbrArray?.map((abbr) => ABBREVIATION_TO_DAY_OF_WEEK[abbr])

/**
 * Capitalizes the first letter of a string
 * @param {string} string - the string to capitalize
 * @returns {string} the capitalized string
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1)

export const getDefaultTimeZoneAbbreviation = () =>
  Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone === 'UTC' ?
    'Etc/GMT'
  : Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function toTimeZone(time, customTimeZone) {
  return moment(time || new Date())?.tz(customTimeZone)
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const parseUserDateTime = (dateTime, timeZone, withTime = true) =>
  moment(dateTime)
    .parseZone()
    .tz(timeZone, false)
    .format(`MMM DD YYYY${withTime ? ', h:mma' : ''}`)

const isValidIANATimezone = (zone: string) => Intl.supportedValuesOf('timeZone').includes(zone)

export const parseTimeZone = (zone?: string | null): string => {
  if (!zone) return Intl.DateTimeFormat().resolvedOptions().timeZone
  if (isValidIANATimezone(zone)) return zone
  const iana = findIana(zone)[0]
  if (!iana) {
    addSentryBreadcrumb({ category: 'timezone', message: `Unrecognized timezone: ${zone}`, level: 'warning' })
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  }
  return iana
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function isDrugScreenTagClickable(status) {
  return status !== DRUG_SCREEN_STATUS.due && status !== DRUG_SCREEN_STATUS.exempt
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function isIDVerificationClickable(status) {
  return (
    status !== ID_VERIFICATION_STATUSES.requested &&
    status !== ID_VERIFICATION_STATUSES.legacyverified &&
    status !== ID_VERIFICATION_STATUSES.unverified
  )
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const compareArray = (a, b) => {
  if (a?.length === b?.length) {
    for (let i = 0; i < a?.length; i += 1) {
      if (!isEqual(a[i], b[i])) {
        return false
      }
    }
  } else {
    return false
  }
  return true
}

/**
 * Replaces the timezone and/or time of the first date string with the timezone and/or time from the second date string.
 *
 * @param {string} date1 - The first date string (e.g., "2024-09-06T00:00:00.000-11:00") whose timezone and/or time will be replaced.
 * @param {string} date2 - The second date string (e.g., "2024-09-07T02:04:06.000-07:00") from which the timezone and/or time will be extracted.
 * @param {boolean} [adjustTimeOnly=false] - If true, only the time will be replaced, keeping the timezone of date1.
 * @param {boolean} [adjustTimezoneOnly=false] - If true, only the timezone will be replaced, keeping the time of date1.
 * @returns {string} The updated date1 string with the adjusted time and/or timezone.
 *
 * @example
 * const date1 = "2024-09-06T01:02:04.000-11:00";
 * const date2 = "2024-09-07T02:04:06.000-07:00";
 *
 * // Replace both time and timezone
 * const result1 = replaceTimezone(date1, date2);
 * console.log(result1); // "2024-09-06T02:04:06.000-07:00"
 *
 * // Replace only time, keeping original timezone
 * const result2 = replaceTimezone(date1, date2, true);
 * console.log(result2); // "2024-09-06T02:04:06.000-11:00"
 *
 * // Replace only timezone, keeping original time
 * const result3 = replaceTimezone(date1, date2, false, true);
 * console.log(result3); // "2024-09-06T01:02:04.000-07:00"
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function replaceTimeZone(date1, date2, adjustTimeOnly = false, adjustTimezoneOnly = false) {
  // Extract the time and timezone parts from both dates
  const timeAndTimezone1 = date1?.slice(-18) // Extracts the last 18 characters (the time and timezone)
  const timeAndTimezone2 = date2?.slice(-18)

  // Extract the time parts (from "T" to the milliseconds, i.e., "T01:02:04.000")
  const time1 = timeAndTimezone1?.slice(0, 12) // Extracts the time only from date1
  const time2 = timeAndTimezone2?.slice(0, 12) // Extracts the time only from date2

  // Extract the timezone parts (e.g., "-11:00" and "-07:00")
  const timezone1 = timeAndTimezone1?.slice(-6) // Extracts the timezone from date1
  const timezone2 = timeAndTimezone2?.slice(-6) // Extracts the timezone from date2

  // Determine the new value based on the flags (adjustTimeOnly, adjustTimezoneOnly)
  let updatedTimeAndTimezone

  if (adjustTimeOnly) {
    updatedTimeAndTimezone = time2 + timezone1 // Replace only time, keeping the original timezone
  } else if (adjustTimezoneOnly) {
    updatedTimeAndTimezone = time1 + timezone2 // Replace only timezone, keeping the original time
  } else {
    updatedTimeAndTimezone = time2 + timezone2 // Replace both time and timezone
  }
  // Replace the time and/or timezone in date1 with the updated values
  const updatedDate = date1?.replace(timeAndTimezone1, updatedTimeAndTimezone)

  return updatedDate
}

/**
 * Filters an array of objects to ensure that each object has a unique value for a specified field.
 *
 * @param {Object[]} array - The array of objects to filter.
 * @param {string} field - The name of the field to check for uniqueness.
 * @returns {Object[]} A new array with objects that have unique values for the specified field.
 *
 * @example
 * const data = [
 *   { id: 1, name: 'Alice' },
 *   { id: 2, name: 'Bob' },
 *   { id: 1, name: 'Charlie' },
 *   { id: 3, name: 'David' },
 * ];
 *
 * const uniqueById = uniqueByField(data, 'id');
 * // Result: [
 * //   { id: 1, name: 'Alice' },
 * //   { id: 2, name: 'Bob' },
 * //   { id: 3, name: 'David' }
 * // ]
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function uniqueByField(array, field) {
  const seen = new Set()
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return array.filter((obj) => {
    if (!seen.has(obj[field])) {
      seen.add(obj[field])
      return true
    }
    return false
  })
}

export const SUPPORTED_TYPES = ['jpg', 'jpeg', 'heic', 'png', 'bmp', 'pdf']
